import React from "react";
import useExport from "./useExport";
import Button from "../Button";

const ExportCognito = ({ loading = true }) => {
    const { exportDownloadRef, exportDownload, doingAjax, handleExport, downloadInitiated } = useExport();

    React.useEffect(() => {
        if (exportDownload !== '') {
            exportDownloadRef.current?.click();
            downloadInitiated();
        }
    }, [exportDownload]);

    return (
        <>
            <Button type="primary" disabled={loading || doingAjax} onClick={handleExport} interactive={false}>
                Export Users
            </Button>
            <a
                hidden
                ref={exportDownloadRef}
                href={exportDownload}
            >
                Download Cognito export
            </a>
        </>
    );
};

export default ExportCognito;
